import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MDialog, { ACTION_CLOSE } from "components/Shared/MDialog.tsx";
import { MSpinner } from "components/Shared";
import { moveToMap } from "requests/schedulingAssistant";
import responseHandler from "responseHandler";
import { Button } from "react-md";

interface MoveToMapProps {
  insuranceCases: Int32Array[];
  visible: boolean;
  makeToast:  (arg1, arg2) => void;
  hideDialog: () => void;
}

const MoveToMap = (props : MoveToMapProps) => {
  const [sendingReq, setSendingReq] = useState<boolean>(false);
  const mounted = useRef(true);
  useEffect(() => {
    return (() => { mounted.current = false; });
  }, []);

  const hasInsuranceCases = props.insuranceCases?.length > 0;

  let dialogText;
  if (props.insuranceCases === null || sendingReq) {
    dialogText = <MSpinner />;
  } else if (hasInsuranceCases) {
    dialogText = "Are you sure you would like to move these cases to the map?";
  } else {
    dialogText = "There are no cases selected.";
  }

  const moveToMapRequest = () => {
    setSendingReq(true);
    moveToMap({
      ControlNumbers: props.insuranceCases,
      TimeLog: null,
    }, () => {
      props.makeToast("Cases moved to the Map, please refresh the QuickList.", "success");
      setSendingReq(false);
      props.hideDialog();
    }, () => {
      setSendingReq(false);
      props.hideDialog();
    }, mounted);
  };

  return (
    <MDialog
      id="move-to-Map-dialog"
      title="Move to Map"
      actions={[{ code: ACTION_CLOSE, onClick: props.hideDialog }]}
      contentActions={[
        <Button key="moveToMapKey" primary raised disabled={!hasInsuranceCases} onClick={() => moveToMapRequest()} >Move to Map</Button>
      ]}
      visible={props.visible}
    >
      <p>{dialogText}</p>
    </MDialog>
  );
};

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(null, mapDispatchToProps)(MoveToMap);